import { coreUsersAdminPatchSlice } from './patch';

export const { requestPatchCoreUsersAdmin, resetPatchCoreUsersAdmin } = coreUsersAdminPatchSlice.asyncActionCreators;
